
import router from "@/router";

const name = 'g-steps'
export default {
  name,

  components: { },
  watch: {
    '$route': function(){
      this.verificaRoute()
    }
  },
  props: {
    items: {
      type: Array,
      default: []
    },
    metadeLargura: {
      type: Boolean,
      default: false,
    }
  },
  mounted () {
    this.verificaRoute()
   },

  updated () { },

  data () {
    return {
        formObject: {},
        itemsJaPassados: [],
        teste: null
     }
  },

  methods: {
    verificaRoute () {
      let route =  this.items.findIndex((Element) => Element.to === window.location.pathname )
      this.$emit('RouterIndex', route)
    },
    nextPage(event) {
        for (let field in event.formData) {
            this.formObject[field] = event.formData[field];
        }

        router.push(this.items[event.pageIndex + 1].to);
    },
    prevPage(event) {
        router.push(this.items[event.pageIndex - 1].to);
    },
    caminho (link) {
        router.push(link)
    }
    },

  computed: {
    ehDesenvolvimento(){
      // return process.env.VUE_APP_WEB_API === "https://apigrupojauensedev.azurewebsites.net/"
      return true
    },

    larguraSteps(){
      return this.metadeLargura ? '50%' : '100%'
    }
  },

};